import * as Yup from 'yup';

export interface Options {
  PrincipalName: string;
  PrincipalFilingState: string | null;
  PrincipalHasEstateTax: boolean;

  SpouseName: string | null;
  SpouseFilingState: string | null;
  SpouseHasEstateTax: boolean;
}

export interface FormValues {
  StateTaxRate: null | number;
  StateTaxLowerLimitAmount: null | number;
  FederalTaxRate: null | number;
  FederalTaxLowerLimitAmount: null | number;

  SpouseStateTaxRate: null | number;
  SpouseStateTaxLowerLimitAmount: null | number;
  SpouseFederalTaxRate: null | number;
  SpouseFederalTaxLowerLimitAmount: null | number;
}

const validateTaxPercentage = Yup.number()
  .nullable()
  .transform(value => (Number.isNaN(value) ? undefined : value))
  .required('Tax rate is required.')
  .max(100, 'The tax rate must between 0 and 100')
  .min(0, 'The tax rate must between 0 and 100');

export const FORM_SCHEMA = Yup.object({
  FederalTaxRate: validateTaxPercentage,

  StateTaxRate: Yup.number()
    .nullable()
    .when('$PrincipalHasEstateTax', {
      is: true,
      then: validateTaxPercentage,
    }),

  SpouseStateTaxRate: Yup.number()
    .nullable()
    .when(['$SpouseName', '$SpouseHasEstateTax'], {
      is: (spouseName, hasEstateTax) => !!spouseName && hasEstateTax,
      then: validateTaxPercentage,
    }),
  SpouseFederalTaxRate: Yup.number()
    .nullable()
    .when('$SpouseName', {
      is: value => !!value,
      then: validateTaxPercentage,
    }),
});
